export const columnsTracking = [
  { id: "idEmpresa", title: "Empresa", width: "15%", position: "EMPDESXX" },
  { id: "idProceso", title: "Proceso", width: "15%", position: "AREADESX" },
  { id: "idSerie", title: "Serie", width: "15%", position: "SERIEDES" },
  { id: "idTipo", title: "Tipo Documental", width: "15%", position: "TIPODESX" },
  { id: "idTipoPadre", title: "Tiene doc. padre", width: "10%", position: "BANAPLPA" },
  { id: "idModificadoPor", title: "Modificado Por", width: "10%", position: "REGUSRNM" },
  { id: "idFechaModificacion", title: "Fecha de modificación", width: "10%", position: "REGFECMX" },
];

export const buttons = [
  { id: "idVerProceso", class: "bi bi-eye-fill", title: "Ver" },
  { id: "idEditarProceso", class: "bi bi-pencil-square", title: "Editar" },
];
